/*
 * Copyright © HatioLab Inc. All rights reserved.
 */

import { Component as SceneComponent, Layer as SceneLayer } from '@hatiolab/things-scene'

export default class ConfidentialOverlay extends SceneLayer {
  _draw(context: CanvasRenderingContext2D) {
    context.globalAlpha = 0.3

    context.font = '50px Verdana'
    context.fillStyle = 'red'

    context.fillText(this.get('text') || 'CONFIDENTIAL', 20, 60)
  }
}

SceneComponent.register('confidential-overlay', ConfidentialOverlay)
